import PropTypes from 'prop-types';
import React from 'react';

import { LocaleService } from '@sm360/widget-commons-core-services';

import MotoInsightCTA from 'commons-vehicle/Vehicle/components/CallToAction/ThirdParties/MotoInsight/MotoInsightCTA.jsx';
import RoadsterCTA from 'commons-vehicle/Vehicle/components/CallToAction/ThirdParties/Roadster/RoadsterCTA.jsx';
import ShopClickDriveCTA from 'commons-vehicle/Vehicle/components/CallToAction/ThirdParties/ShopClickDrive/ShopClickDriveCTA.jsx';
import EshopCTA from 'commons-vehicle/Vehicle/components/CallToAction/ThirdParties/Eshop/EshopCTA.jsx';

const ThirdPartiesCTA = ({
    motoInsightEnabled,
    roadsterEnabled,
    shopClickDriveEnabled,
    eshopEnabled,
    roadsterLink,
    dealerBAC,
    dealerCode,
    vehicle,
    eshopExtraClass,
    roadsterCZCtaLabel,
    shopClickDriveCZCtaLabel,
}) => {
    const locale = LocaleService.getSimpleLocale();
    return (
        <div className="third-parties-ctas">
            {motoInsightEnabled && (
                <MotoInsightCTA
                    serialNo={vehicle?.vin}
                    ctaLabel={LocaleService.t('CALL_TO_ACTION.BTN_MOTO_INSIGHT_TEXT')}
                />
            )}
            {roadsterEnabled && (
                <RoadsterCTA
                    serialNo={vehicle?.vin}
                    ctaLabel={roadsterCZCtaLabel}
                    lang={locale}
                    buttonLink={roadsterLink}
                />
            )}
            {shopClickDriveEnabled &&
                dealerBAC && (
                    <ShopClickDriveCTA
                        ctaLabel={shopClickDriveCZCtaLabel}
                        dealerBac={dealerBAC}
                        make={vehicle?.make?.slug}
                        serialNo={vehicle?.vin}
                        lang={locale}
                    />
                )}
            {eshopEnabled &&
                dealerCode && (
                    <EshopCTA
                        serialNo={vehicle?.vin}
                        dealerCode={dealerCode}
                        lang={locale}
                        newVehicle={vehicle?.getIsVehicleNew()}
                        extraClass={eshopExtraClass}
                    />
                )}
        </div>
    );
};

ThirdPartiesCTA.defaultProps = {
    motoInsightEnabled: false,
    roadsterEnabled: false,
    eshopEnabled: false,
    shopClickDriveEnabled: false,
    roadsterLink: '',
    dealerCode: '',
    dealerBAC: '',
    eshopExtraClass: '',
    vehicle: {},
    roadsterCZCtaLabel: '',
    shopClickDriveCZCtaLabel: '',
};

ThirdPartiesCTA.propTypes = {
    motoInsightEnabled: PropTypes.bool,
    roadsterEnabled: PropTypes.bool,
    eshopEnabled: PropTypes.bool,
    shopClickDriveEnabled: PropTypes.bool,
    roadsterLink: PropTypes.string,
    dealerCode: PropTypes.string,
    dealerBAC: PropTypes.string,
    eshopExtraClass: PropTypes.string,
    vehicle: PropTypes.object,
    roadsterCZCtaLabel: PropTypes.string,
    shopClickDriveCZCtaLabel: PropTypes.string,
};

ThirdPartiesCTA.displayName = 'ThirdPartiesCTA';

export default ThirdPartiesCTA;
